import { create } from 'zustand';
import type { MainView } from '../core/domain/types';

interface UiState {
  view: MainView;
  selectedCropId: string;
  selectedFurnitureInstanceId: string | null;
  notice: string | null;
  setView(view: MainView): void;
  selectCrop(cropId: string): void;
  selectFurniture(instanceId: string | null): void;
  showNotice(message: string): void;
  clearNotice(): void;
}

export const useUiStore = create<UiState>((set) => ({
  view: 'farm',
  selectedCropId: 'crop_radish',
  selectedFurnitureInstanceId: null,
  notice: null,
  setView: (view) => set({ view, selectedFurnitureInstanceId: null }),
  selectCrop: (selectedCropId) => set({ selectedCropId }),
  selectFurniture: (selectedFurnitureInstanceId) => set({ selectedFurnitureInstanceId }),
  showNotice: (notice) => {
    set({ notice });
    window.setTimeout(
      () => set((state) => (state.notice === notice ? { notice: null } : state)),
      2200,
    );
  },
  clearNotice: () => set({ notice: null }),
}));
